import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import type { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';
import cx from 'classnames';
import { useTheme } from 'styled-components';

interface IconProps extends Omit<AntdIconProps, 'ref'> {
  addLeftMargin?: boolean;
}

export const CheckIcon = ({ className, addLeftMargin = true, ...props }: IconProps) => {
  const theme = useTheme();

  return (
    <CheckCircleTwoTone
      {...props}
      className={cx('confirmed-icon', className)}
      twoToneColor={theme.green}
      style={{ marginLeft: addLeftMargin ? '0.25rem' : '0rem' }}
    />
  );
};

export const CloseIcon = (props: IconProps) => {
  const theme = useTheme();

  return <CloseCircleTwoTone {...props} twoToneColor={theme.red} />;
};
